import React from 'react'

import { useStyles } from './side-by-side-chart-container.style'
import { SideBySideChartContextProvider } from '../contexts/side-by-side.context'

export const SideBySideChartContainer = function ({ children, className = '', ...props }) {
  const classes = useStyles()

  return (
    <SideBySideChartContextProvider>
      <div data-qa="side-by-side-chart-container" className={`${classes.sideBySideChartContainer} ${className}`} {...props}>
        {children}
      </div>
    </SideBySideChartContextProvider>
  )
}
